import { useMemo } from "react";
const useTagName = (as) => {
  return useMemo(() => {
    return as || "div";
  }, [as]);
};
export {
  useTagName as u
};
//# sourceMappingURL=useTagName.COq0HFfN.mjs.map
